import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/default.jsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "about"
    }}>{`About`}</h2>
    <p>{`This starter is based on `}<a parentName="p" {...{
        "href": "https://github.com/Vagr9K/gatsby-advanced-starter"
      }}>{`Gatsby Advance Starter`}</a>{` and further develop into a separate starter with custom basic features. This is the first attempt for me contributing to the community, so please let me know if there are anythings that can be improved.`}</p>
    <p>{`This starter would be a great place to start if you are looking for a clean and minimal blog setup, at the same time following the latest design trend with Dark Mode, supporting latest Gatsby features. Moderate code editing will be required in order to launch the site.`}</p>
    <h2 {...{
      "id": "like-this-starter-give-me-a-star-on-github"
    }}>{`Like this starter? Give me a star on Github`}</h2>
    <p><a parentName="p" {...{
        "href": "https://github.com/desktopofsamuel/gatsby-starter-lamma"
      }}>{`Gatsby Starter Lamma on Github`}</a></p>
    <h2 {...{
      "id": "follow-me-on-twitter-for-latest-update"
    }}>{`Follow me on Twitter for latest update!`}</h2>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/desktopofsamuel"
      }}>{`Twitter`}</a></p>
    <h2 {...{
      "id": "about-the-maker"
    }}>{`About the maker`}</h2>
    <p>{`Hi! My name is Samuel, I'm a UI/UX Designer based in Hong Kong. I create this starter because I noticed there isn't many blog templates with default Dark Mode and MDX implementation. So I decided to create one myself.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      